<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 82 100">
    <g :fill="iconColor" fill-rule="evenodd">
      <path
        d="M47.474 60.12h3.956l2.336 3.37 2.355-3.37h3.899l-4.295 6.046 5.048 7.059h-3.975l-3.089-4.363-3.07 4.363H46.72l5.048-7.04-4.295-6.066zm-7.384 9.23c.766.686 1.727 1.029 2.882 1.029 1.382 0 2.537-.35 3.466-1.049v3.333c-1.08.55-2.285.824-3.616.824-2.11 0-3.862-.637-5.256-1.91-1.394-1.273-2.09-2.908-2.09-4.905 0-1.997.69-3.632 2.071-4.905 1.394-1.274 3.146-1.91 5.256-1.91 1.255 0 2.392.25 3.41.749v3.314a6.292 6.292 0 0 0-3.372-.955c-1.106 0-2.029.35-2.77 1.048-.74.7-1.11 1.585-1.11 2.659 0 1.098.376 1.99 1.13 2.677zm-19.74-2.678c0-1.897.659-3.507 1.977-4.83 1.319-1.323 2.976-1.985 4.973-1.985 1.997 0 3.655.662 4.973 1.984 1.319 1.324 1.978 2.934 1.978 4.83 0 1.898-.66 3.508-1.978 4.831-1.318 1.323-2.976 1.985-4.973 1.985-1.997 0-3.654-.662-4.973-1.985-1.318-1.323-1.978-2.933-1.978-4.83zm50.857 26.81H16.07c-2.287 0-4.148-1.85-4.148-4.125v-4.77h51.4c2.384 0 4.316-1.918 4.316-4.288v-26.01c0-2.37-1.932-4.29-4.315-4.29H11.922V10.644c0-2.269 1.861-4.119 4.148-4.119l37.957-.04V20.43c0 4.073 3.325 7.38 7.426 7.38l13.743-.039.155 61.586c0 2.275-1.857 4.125-4.144 4.125zM6.58 73.225V60.119h5.256c2.135 0 3.887.612 5.256 1.835 1.356 1.223 2.034 2.796 2.034 4.718 0 1.947-.678 3.526-2.034 4.736-1.345 1.211-3.096 1.817-5.256 1.817H6.579zM56.48 0H16.07C10.166 0 5.36 4.779 5.36 10.643V50H4.316C1.932 50 0 51.92 0 54.289v26.01c0 2.37 1.932 4.288 4.315 4.288h1.046v4.77C5.36 95.227 10.166 100 16.07 100h55.137c5.901 0 10.707-4.773 10.707-10.643V25.19L56.48 0z"
      />
      <path
        d="M11.59 63.077H9.97v7.19h1.62c1.281 0 2.273-.312 2.976-.937.703-.624 1.055-1.51 1.055-2.658s-.352-2.035-1.055-2.659c-.703-.624-1.695-.936-2.976-.936M29.768 69.33c.665-.698.998-1.585.998-2.658 0-1.074-.333-1.96-.998-2.659-.666-.699-1.488-1.048-2.468-1.048-.992 0-1.82.35-2.486 1.048-.653.687-.98 1.573-.98 2.659 0 1.086.327 1.972.98 2.658.665.7 1.494 1.049 2.486 1.049.98 0 1.802-.35 2.468-1.049"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-docx',
    props: {
      width: {
        type: [Number, String],
        default: 82
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
